<template>
  <div>
    <h4>Mehrwertsteuer</h4>
    <div class="card p-3">
      <b-form-row>
        <b-col :md="canHaveZero ? 3 : 6">
            <b-select
                :options="taxRates" id="tax-rates-select"
                v-model="selectedTaxRate"
                @change="hasChanged()"
                :disabled="hasNoTax"
            ></b-select>
        </b-col>
        <b-col md="9" v-if="canHaveZero">
            <b-checkbox
                class="pt-2"
                label="Ich bin nicht Mehrwertsteuerpflichtig."
                v-model="hasNoTax"
                @change="toggleNoTax()"
            >
              Ich bin nicht Mehrwertsteuerpflichtig.
            </b-checkbox>
        </b-col>
      </b-form-row>
      <div>
        <b-spinner v-if="inProgress" small style="position: absolute; right: 15px; top: 15px;"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import collections from "@/api/collections";
import products from "@/api/products";
import platformSettings from '~config/settings'

export default {
  props: ['collections'],
  inject: ['showSuccessAlert'],
  data() {
    return {
      selectedTaxRate: null,
      inProgress: false,
      taxRates: platformSettings.taxRates,
      canHaveZero: platformSettings.taxRates.length > 0 && platformSettings.taxRates.map(e => e.value).includes('tax_0'),
      hasNoTax: false
    }
  },
  computed: {
    productId () {
      return this.$route.params.id
    },
    initialTaxRate(){
      try {
        return this.collections.find(c => c.title.startsWith('tax_')).title
      } catch {
        return '';
      }

    },
    changed(){
      return this.initialTaxRate !== this.selectedTaxRate
    }
  },
  methods: {
    async removeFromOtherTaxCollections(){
      products.getProduct(this.productId).then(
          async product => {
            const collectionsToRemoveFrom = product.collections.filter(
                c => (c.title !== this.selectedTaxRate) && (c.title.startsWith('tax_'))
                )
            for (const collection of collectionsToRemoveFrom) {
              await products.removeFromCollection(this.productId, collection.id)
            }
          }
      )
    },
    toggleNoTax() {
        if (this.hasNoTax) {
            this.selectedTaxRate = 'tax_0'
            this.save()
        }
    },
    hasChanged() {
        this.save()
    },
    async save(){
      if (!this.changed) return
      this.inProgress = true
      let response = await collections.getByTitle(this.selectedTaxRate);
      if (response.data.length === 0){
        const newCollection = await collections.create(this.selectedTaxRate)
        products.addToCollection(this.productId, newCollection.data.id).then(
            async () => {
              this.removeFromOtherTaxCollections()
                  .then(() => this.$emit('tax-changed'))
                  .finally(() =>this.inProgress = false)
            }
        ).then( () => {
          this.showSuccessAlert('Änderung ist gespeichert')
        })

      }else {
        products.addToCollection(this.productId, response.data[0].id).then(
            async () => {
              this.removeFromOtherTaxCollections()
                  .then(() => this.$emit('tax-changed'))
                  .finally(() =>  this.inProgress = false)
            }
        )
        .then(()=> {
          this.showSuccessAlert('Änderung ist gespeichert')
        })
        }
      }
  },
  created(){
    this.selectedTaxRate = this.initialTaxRate;
    if (this.initialTaxRate === 'tax_0') {
      this.hasNoTax = true
    }
  }
}
</script>
